var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isZaiart)?_c('div',{staticClass:"app-bar"},[_c('div',{staticClass:"inner",style:(_vm.style)},[_c('div',{staticClass:"zaiart-icon"}),_c('a',{staticClass:"open-btn js-goApp",attrs:{"href":"javascript:;"}},[_vm._v("立即打开")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }